/* Northern Ridge Nursery redesign (Oct 2026): location, ship windows, product buy box, home personalization. */
(function () {
  'use strict';
  var API = 'https://nrn-plugin.northernridgenursery.com/api';
  var KEY = 'nrn_loc_v1';
  var STATE_NAMES = { AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',DC:'Washington, DC',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming' };
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function fmtDate(iso) { var p = String(iso).split('-'); return MONTHS[+p[1] - 1] + ' ' + (+p[2]); }
  /* The order-by date is a suggestion; orders after it still ship. Once it passes, say "order now". */
  function orderBy(w, cap) { var t = (w.pastDeadline || (w.daysToDeadline != null && w.daysToDeadline < 0)) ? "order now" : "order by " + fmtDate(w.deadline); return cap ? t.charAt(0).toUpperCase() + t.slice(1) : t; }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function store(v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(KEY) || 'null'); localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { return null; } }

  /* ---------------- Location ---------------- */
  var Loc = { current: null, listeners: [] };
  Loc.on = function (fn) { Loc.listeners.push(fn); if (Loc.current) fn(Loc.current); };
  Loc.set = function (loc) {
    Loc.current = loc; store(loc);
    $all('[data-nrn-loc-text]').forEach(function (el) {
      el.textContent = loc ? ((loc.city ? loc.city + ', ' : '') + (loc.state || '') + ' ' + loc.zip + ' · Zone ' + loc.zoneFull) : 'Set your ZIP for ship dates';
    });
    $all('[data-nrn-loc-zone]').forEach(function (el) { el.textContent = loc ? loc.zoneFull : ''; });
    Loc.listeners.forEach(function (fn) { try { fn(loc); } catch (e) { console.warn(e); } });
    if (typeof track === "function" && (!Loc._tracked || (loc && Loc._tracked !== loc.zip))) { Loc._tracked = loc ? loc.zip : "none"; track(loc ? "location" : "location_none", loc ? { source: loc.source } : {}); }
  };
  Loc.fromZip = function (zip, source) {
    return fetch(API + '/zone?zip=' + encodeURIComponent(zip)).then(function (r) { if (!r.ok) throw new Error('zone'); return r.json(); }).then(function (z) {
      var loc = { zip: z.zip, city: z.city, state: z.state, zone: z.zone, zoneFull: z.zoneFull, windows: z.windows || [], source: source || 'zip', ts: Date.now() };
      shareWithWidget(z, loc.source); Loc.set(loc); return loc;
    });
  };
  /* Keep the site-wide zone widget (plugin widget.js) on the same location: it reads these keys on every page. */
  function shareWithWidget(z, source) {
    try {
      localStorage.setItem("nrn_zip", z.zip); localStorage.setItem("nrn_zone", JSON.stringify(z));
      if (z.city) localStorage.setItem("nrn_city", z.city); if (z.state) localStorage.setItem("nrn_state", z.state);
      localStorage.setItem("nrn_auto_detected", source === "ip" ? "1" : "0");
    } catch (e) {}
  }
  function widgetManualZip() { try { return localStorage.getItem("nrn_auto_detected") === "0" ? localStorage.getItem("nrn_zip") : null; } catch (e) { return null; } }
  Loc.init = function () {
    var saved = store();
    var fresh = saved && saved.zip && saved.ts && (Date.now() - saved.ts) < 1000 * 60 * 60 * 24 * 30;
    /* A ZIP the visitor typed or a GPS fix sticks for 30 days. An IP guess is shown right away but re-checked every page load (VPNs, travel, phones). */
    /* A ZIP typed into the site-wide widget on another page wins over anything older here. */
    var wz = widgetManualZip();
    if (wz && /^\d{5}$/.test(wz) && !(fresh && saved.source !== "ip" && saved.zip === wz)) { if (fresh && saved.zip === wz) Loc.set(saved); Loc.fromZip(wz, "zip").catch(function () {}); return; }
    if (fresh && saved.source !== "ip") { Loc.set(saved); return; }
    if (fresh) Loc.set(saved);
    fetch(API + "/geo", { cache: "no-store" }).then(function (r) { return r.json(); }).then(function (g) {
      if (g && g.found && g.zip) { if (!fresh || g.zip !== saved.zip) return Loc.fromZip(g.zip, "ip"); return; }
      if (fresh) { try { localStorage.removeItem(KEY); } catch (e) {} }
      Loc.set(null);
    }).catch(function () { if (!fresh) Loc.set(null); });
  };
  window.NRNLoc = Loc;

  /* ---------------- Dialogs ---------------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-nrn-open]');
    if (open && open.hasAttribute('data-nrn-close')) { var pd = open.closest('dialog'); if (pd) pd.close(); }
    if (open) { var d = document.getElementById(open.getAttribute('data-nrn-open')); if (d && d.showModal) { e.preventDefault(); d.showModal(); } return; }
    var close = e.target.closest('[data-nrn-close]');
    if (close) { var dl = close.closest('dialog'); if (dl) dl.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('nrn-dialog')) e.target.close();
  });

  function initLocDialog() {
    var dlg = document.getElementById('nrn-loc-dialog');
    if (!dlg) return;
    var form = $('form', dlg), input = $('input[name=zip]', dlg), msg = $('[data-nrn-loc-msg]', dlg), gps = $('[data-nrn-gps]', dlg);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var zip = (input.value || '').trim();
      if (!/^\d{5}$/.test(zip)) { msg.textContent = 'Enter a 5-digit ZIP code.'; return; }
      msg.textContent = 'Looking up your zone…';
      Loc.fromZip(zip, 'zip').then(function () { msg.textContent = ''; dlg.close(); }).catch(function () { msg.textContent = 'We couldn’t find that ZIP. Try again.'; });
    });
    if (gps) gps.addEventListener('click', function () {
      if (!navigator.geolocation) { msg.textContent = 'Your browser can’t share location. Enter your ZIP instead.'; return; }
      msg.textContent = 'Finding your location…';
      navigator.geolocation.getCurrentPosition(function (p) {
        fetch(API + '/geo?lat=' + p.coords.latitude.toFixed(4) + '&lon=' + p.coords.longitude.toFixed(4)).then(function (r) { return r.json(); }).then(function (g) {
          if (!g.found) throw new Error('nf');
          return Loc.fromZip(g.zip, 'gps');
        }).then(function () { msg.textContent = ''; dlg.close(); }).catch(function () { msg.textContent = 'Couldn’t match your location. Enter your ZIP instead.'; });
      }, function () { msg.textContent = 'Location was not shared. Enter your ZIP instead.'; }, { timeout: 10000, maximumAge: 600000 });
    });
  }

  /* ---------------- Product page ---------------- */
  function initPDP(root) {
    var data; try { data = JSON.parse($('#nrn-pdp-data', root).textContent); } catch (e) { return; }
    var form = document.getElementById(data.formId);
    if (!form) return;
    var idInput = $('input[name=id]', form), qtyInput = $('input[name=quantity]', form);
    var submit = $('.product-form__submit', root), submitLabel = $('[data-nrn-atc-label]', root);
    var payBtn = $('.nrn-atc .shopify-payment-button', root) || null;
    var state = { size: data.sizes.length ? data.sizes[0] : null, season: null, qty: data.needsPartner ? 2 : 1, pairOk: false };

    function seasonOf(v) { var t = (v.options || []).join(' ').toUpperCase(); return /NOV|FALL|DEC|JAN|FEB/.test(t) && !/MAR|SPRING/.test(t) ? 'fall' : (/MAR|SPRING|APR|MAY/.test(t) ? 'spring' : 'any'); }
    data.variants.forEach(function (v) { v.season = seasonOf(v); });
    function variantFor(size, season) {
      return data.variants.filter(function (v) { return (!data.sizes.length || v.options[data.sizeIndex] === size) && (season === 'any' || v.season === season || v.season === 'any'); })
        .sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); })[0];
    }
    function blockedState() { var l = Loc.current; return l && l.state && data.cantShip.indexOf(l.state) !== -1 ? l.state : null; }
    function zoneWindows() { var l = Loc.current; return l && l.windows ? l.windows : []; }

    function renderSeasons() {
      var wins = zoneWindows(), loc = Loc.current, blocked = blockedState();
      var anyAvail = null;
      $all('[data-nrn-season]', root).forEach(function (btn) {
        var key = btn.getAttribute('data-nrn-season');
        var v = variantFor(state.size, key);
        var win = wins.filter(function (w) { return w.season === key; })[0];
        var zoneNoFall = loc && key === 'fall' && wins.length && !win;
        var avail = !!(v && v.available) && !blocked && !zoneNoFall;
        btn.setAttribute('aria-disabled', avail ? 'false' : 'true');
        var line = $('[data-line]', btn), sub = $('[data-sub]', btn), badge = $('[data-badge]', btn);
        if (blocked) { line.textContent = 'Can’t ship to ' + (STATE_NAMES[blocked] || blocked); sub.textContent = 'State plant rules. Tap to see why.'; badge.textContent = ''; }
        else if (zoneNoFall) { line.textContent = 'No fall shipping to Zone ' + loc.zoneFull; sub.textContent = 'Your zone gets spring shipping only.'; badge.textContent = ''; }
        else if (!v || !v.available) { line.textContent = 'Sold out for this window'; sub.textContent = ''; badge.textContent = ''; }
        else {
          line.textContent = win ? ('Ships ' + fmtDate(win.start) + ' – ' + fmtDate(win.end) + ', ' + win.yearLabel) : btn.getAttribute('data-default-window');
          sub.textContent = win ? (orderBy(win, true) + (win.urgent ? ' (soon!)' : '')) : (loc ? '' : 'Add your ZIP for exact dates');
          badge.textContent = v.inventory > 0 && v.inventory <= 120 ? ('Only ' + v.inventory + ' left') : '';
        }
        btn.dataset.avail = avail ? '1' : '0';
        if (avail && !anyAvail) anyAvail = key;
      });
      if (!state.season || $('[data-nrn-season="' + state.season + '"]', root).dataset.avail !== '1') state.season = anyAvail;
      $all('[data-nrn-season]', root).forEach(function (btn) { btn.setAttribute('aria-pressed', btn.getAttribute('data-nrn-season') === state.season ? 'true' : 'false'); });
    }

    function render() {
      renderSeasons();
      var blocked = blockedState();
      var v = state.season ? variantFor(state.size, state.season) : null;
      if (v) idInput.value = v.id;
      qtyInput.value = state.qty;
      $all('[data-nrn-qty]', root).forEach(function (b) { var on = +b.getAttribute('data-nrn-qty') === state.qty; b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      $all('[data-nrn-qty-out]', root).forEach(function (o) { o.textContent = state.qty; });
      $all('[data-nrn-size]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-nrn-size') === state.size ? 'true' : 'false'); });
      var price = v ? v.price : data.variants[0].price, compare = v ? v.compare : null;
      $all('[data-nrn-price]', root).forEach(function (el) { el.textContent = money(price); });
      var total = price * state.qty;
      if (blocked) {
        submit.classList.add('is-blocked'); submit.type = 'button'; submitLabel.textContent = 'Why can’t it ship to ' + blocked + '?';
        if (payBtn) payBtn.hidden = true;
      } else if (!v || !v.available) {
        submit.classList.remove('is-blocked'); submit.type = 'submit'; submit.disabled = true; submitLabel.textContent = 'Sold out';
        if (payBtn) payBtn.hidden = true;
      } else {
        submit.classList.remove('is-blocked'); submit.type = 'submit'; submit.disabled = false;
        submitLabel.textContent = 'Add ' + state.qty + ' to cart · ' + money(total);
        if (payBtn) payBtn.hidden = false;
      }
      $all('[data-nrn-sticky-label]').forEach(function (el) { el.textContent = blocked ? 'Can’t ship to ' + blocked : (v && v.available ? 'Add ' + state.qty + ' · ' + money(total) : 'Sold out'); });
      renderAlt();
      var stock = $('[data-nrn-stock]', root);
      if (stock) { stock.hidden = !(v && v.available && v.inventory > 0 && v.inventory <= 120 && !blocked); if (v) stock.textContent = 'Only ' + v.inventory + ' left for ' + (v.season === 'fall' ? 'fall' : 'spring') + ' shipping'; }
      var fs = $('[data-nrn-freeship]', root);
      if (fs) {
        var left = Math.max(0, data.freeShip - total), pct = Math.min(100, Math.round(total / data.freeShip * 100));
        $('[data-text]', fs).textContent = left > 0 ? (money(left) + ' from free shipping') : 'Free shipping unlocked';
        $('span', $('.nrn-freeship__bar', fs)).style.width = pct + '%';
      }
      // zone bar + message
      var loc = Loc.current;
      $all('.nrn-zonebar i', root).forEach(function (i) { i.classList.toggle('mine', !!loc && +i.getAttribute('data-z') === loc.zone); });
      $all('.nrn-zonebar em', root).forEach(function (e) { e.hidden = !(loc && +e.getAttribute('data-z') === loc.zone); });
      var zm = $('[data-nrn-zone-msg]', root);
      if (zm) {
        if (!loc) zm.textContent = '';
        else if (loc.zone >= data.zoneMin && loc.zone <= data.zoneMax) { zm.textContent = 'Zone ' + loc.zoneFull + ' is a great fit.'; zm.style.color = '#214525'; }
        else { zm.textContent = 'Zone ' + loc.zoneFull + ' is outside this plant’s range (' + data.zoneMin + '–' + data.zoneMax + ').'; zm.style.color = '#9A4F1C'; }
      }
      var nsHead = $('[data-nrn-noship-head]'), nsReason = $('[data-nrn-noship-reason]');
      if (nsHead) {
        if (blocked) {
          var nm = STATE_NAMES[blocked] || blocked;
          nsHead.textContent = 'We can’t ship ' + data.name + ' to ' + nm + '.';
          nsReason.textContent = (blocked === 'AK' || blocked === 'HI') ? 'We only ship live bare-root plants within the continental United States.' : nm + ' restricts which nursery plants can be shipped in from other states, to keep out pests and diseases. This plant is on its list.';
        } else { nsHead.textContent = 'Some states restrict this plant.'; nsReason.textContent = 'States set their own rules for live plants coming in from elsewhere, to keep out pests and diseases.'; }
      }
    }

    /* 2026-10-26: sold-out season helper. When one shipping season is sold out (and the shopper's zone could get it),
       say so, point to the season that's still available, and suggest related plants that still ship in the sold-out
       season. Everything is computed from live variant data and the zone windows, so nothing changes per season. */
    var altBox = $('[data-nrn-alt]', root), altCache = {}, altShown = {};
    var SEASON_WORD = { fall: 'fall', spring: 'spring' };
    function altCandidates(season, cb) {
      if (altCache[season]) return cb(altCache[season]);
      if (!data.productId) return cb([]);
      fetch('/recommendations/products.json?product_id=' + data.productId + '&limit=10&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var out = [];
          (j.products || []).forEach(function (p) {
            if (out.length >= 3 || p.id === data.productId || /gift card|second shipment/i.test(p.title)) return;
            var v = (p.variants || []).filter(function (x) { return x.available && seasonOf({ options: x.options || [x.title] }) === season; })[0];
            if (v) out.push({ title: p.title, url: p.url + (p.url.indexOf('?') < 0 ? '?' : '&') + 'variant=' + v.id, img: p.featured_image, price: v.price });
          });
          altCache[season] = out; cb(out);
        })
        .catch(function () { altCache[season] = []; cb([]); });
    }
    function renderAlt() {
      if (!altBox) return;
      if (blockedState()) { altBox.hidden = true; return; }
      var loc = Loc.current, wins = zoneWindows(), sold = null;
      ['fall', 'spring'].forEach(function (key) {
        var btn = $('[data-nrn-season="' + key + '"]', root); if (!btn || sold) return;
        var v = variantFor(state.size, key);
        var zoneNoFall = loc && key === 'fall' && wins.length && !wins.filter(function (w) { return w.season === key; })[0];
        if (!zoneNoFall && !(v && v.available)) sold = key;
      });
      if (!sold) { altBox.hidden = true; return; }
      var other = state.season && state.season !== sold ? state.season : null;
      var otherBtn = other ? $('[data-nrn-season="' + other + '"]', root) : null;
      var otherLine = otherBtn ? ($('[data-line]', otherBtn) || {}).textContent || '' : '';
      var html = '<p class="nrn-alt__head"><b>Sold out for ' + SEASON_WORD[sold] + ' planting.</b> ' +
        (other ? 'You can reserve it now for ' + SEASON_WORD[other] + ' planting (' + otherLine.replace(/^Ships /, 'ships ') + ').' : 'Check back next season.') + '</p>';
      altBox.innerHTML = html; altBox.hidden = false;
      altCandidates(sold, function (list) {
        if (!list.length || altBox.hidden) return;
        altBox.innerHTML = html + '<p class="nrn-alt__k">Similar plants that still ship in ' + SEASON_WORD[sold] + ':</p><ul class="nrn-alt__list" role="list">' +
          list.map(function (a) {
            var img = a.img ? '<img src="' + String(a.img) + (String(a.img).indexOf('?') < 0 ? '?' : '&') + 'width=160' + '" alt="" loading="lazy" width="56" height="56">' : '';
            return '<li><a href="' + a.url + '">' + img + '<span><b>' + a.title.replace(/</g, '&lt;') + '</b><small>' + money(a.price) + ' · ships ' + SEASON_WORD[sold] + '</small></span></a></li>';
          }).join('') + '</ul>';
        if (!altShown[sold]) { altShown[sold] = 1; track('soldout_alt_shown', { product: data.name, season: sold, options: list.length }); }
      });
    }

    root.addEventListener('click', function (e) {
      var s = e.target.closest('[data-nrn-season]');
      if (s) { if (blockedState()) { document.getElementById('nrn-noship-dialog').showModal(); track("cant_ship_shown", { product: data.name }); return; } if (s.dataset.avail === '1') { state.season = s.getAttribute('data-nrn-season'); render(); } return; }
      var q = e.target.closest('[data-nrn-qty]'); if (q) { state.qty = +q.getAttribute('data-nrn-qty'); render(); return; }
      var z = e.target.closest('[data-nrn-size]'); if (z) { state.size = z.getAttribute('data-nrn-size'); render(); return; }
      if (e.target.closest('[data-nrn-inc]')) { state.qty = Math.min(99, state.qty + 1); render(); return; }
      if (e.target.closest('[data-nrn-dec]')) { state.qty = Math.max(1, state.qty - 1); render(); return; }
      if (e.target.closest('.product-form__submit.is-blocked')) { e.preventDefault(); document.getElementById('nrn-noship-dialog').showModal(); track("cant_ship_shown", { product: data.name }); return; }
      var g = e.target.closest('[data-nrn-slide]');
      if (g) { showSlide(+g.getAttribute('data-nrn-slide')); return; }
      if (e.target.closest('[data-nrn-prev]')) { showSlide(cur - 1); return; }
      if (e.target.closest('[data-nrn-next]')) { showSlide(cur + 1); return; }
    });

    // Pollination partner prompt before adding a single plant that needs a partner
    var productForm = form.closest('product-form') || form.parentNode;
    productForm.addEventListener('submit', function (e) {
      if (data.needsPartner && state.qty === 1 && !state.pairOk) {
        e.preventDefault(); e.stopImmediatePropagation();
        document.getElementById('nrn-pair-dialog').showModal();
        track("pair_prompt", { product: data.name });
        return;
      }
      track("pdp_add", { product: data.name, qty: state.qty, season: state.season, needs_partner: !!data.needsPartner });
      var l = Loc.current;
      if (l) { try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Shipping ZIP': l.zip, 'USDA zone': l.zoneFull } }) }); } catch (err) {} }
    }, true);
    $all('[data-nrn-pair-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.qty = +b.getAttribute('data-nrn-pair-add'); state.pairOk = true; render();
        track("pair_choice", { product: data.name, qty: state.qty });
        document.getElementById('nrn-pair-dialog').close();
        form.requestSubmit ? form.requestSubmit(submit) : submit.click();
      });
    });

    // Gallery
    var slides = $all('.nrn-gallery__slide', root), cur = 0;
    function showSlide(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
      $all('[data-nrn-slide]', root).forEach(function (t) { t.setAttribute('aria-pressed', +t.getAttribute('data-nrn-slide') === cur ? 'true' : 'false'); });
      var note = $('[data-nrn-slide-note]', root); if (note) note.textContent = slides[cur].getAttribute('data-note') || '';
    }

    // Sticky add-to-cart on mobile
    var sticky = document.getElementById('nrn-sticky');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting); }).observe(submit);
      $('[data-nrn-sticky-btn]', sticky).addEventListener('click', function () { submit.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { submit.click(); }, 350); });
    }

    Loc.on(render);
    render();
  }

  /* ---------------- Home ---------------- */
  /* ---------------- Merchandising ---------------- */
  var SLOTS = ["H", "H", "P", "H", "P", "H", "H", "P"];
  function seed() { try { var v = sessionStorage.getItem("nrn_seed"); if (!v) { v = String(Math.floor(Math.random() * 1e9)); sessionStorage.setItem("nrn_seed", v); } return +v; } catch (e) { return 7; } }
  function rng(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function merchPick(list, n) {
    var hot = list.slice().sort(function (a, b) { return (+a.getAttribute("data-hot")) - (+b.getAttribute("data-hot")); });
    var pool = list.filter(function (c) { return +c.getAttribute("data-push") > 0; });
    var r = rng(seed()), push = [];
    while (pool.length) { /* weighted draw without replacement: riskier plants come up more often */
      var total = pool.reduce(function (s, c) { return s + (+c.getAttribute("data-push")); }, 0), x = r() * total, i = 0;
      for (; i < pool.length - 1; i++) { x -= +pool[i].getAttribute("data-push"); if (x <= 0) break; }
      push.push(pool.splice(i, 1)[0]);
    }
    var out = [];
    var slots = []; while (slots.length < n) slots = slots.concat(SLOTS);
    slots.slice(0, n).forEach(function (slot) {
      var src = slot === "P" && push.length ? push : hot, c;
      while (src.length && (c = src.shift()) && out.indexOf(c) !== -1) c = null;
      if (!c) { while (hot.length && (c = hot.shift()) && out.indexOf(c) !== -1) c = null; }
      if (c) out.push(c);
    });
    return out;
  }

  /* ---------------- Analytics ----------------
     Every event goes to Shopify customer events (custom pixels can forward to GA4) and to dataLayer/gtag if present. */
  function track(name, data) {
    data = data || {};
    var l = Loc.current; if (l) { data.zone = data.zone || l.zoneFull; data.state = data.state || l.state; data.loc_source = l.source; }
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish("nrn_" + name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: "nrn_" + name }, data)); } catch (e) {}
  }
  window.NRNTrack = track;
  window.NRNKit = { merchPick: function (l, n) { return merchPick(l, n); }, fits: function (c, l) { return cardFits(c, l); }, season: function (c) { return cardSeason(c); } };

  /* ---------------- Interaction (works the same on touch and mouse) ----------------
     Scroll parallax: every [data-nh-par] gets --p from -1 (below the fold) to 1 (scrolled past), on one rAF loop.
     Tilt: tiles lean toward the pointer on mouse/pen; on touch they press in. Off under reduced motion. */
  var REDUCE = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  function initParallax(root) {
    if (REDUCE) return;
    var els = $all("[data-nh-par]", root), ticking = false;
    function frame() {
      ticking = false; var vh = innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect(); if (r.bottom < -200 || r.top > vh + 200) return;
        var p = ((vh / 2) - (r.top + r.height / 2)) / (vh / 2 + r.height / 2);
        el.style.setProperty("--p", Math.max(-1, Math.min(1, p)).toFixed(3));
        if (el.classList.contains("nh-how-wrap")) { /* light each step as the stem reaches it */
          var fill = Math.max(0, Math.min(1, p + 0.55)), lis = el.querySelectorAll(".nh-how li");
          for (var k = 0; k < lis.length; k++) lis[k].classList.toggle("is-lit", fill >= (k + 0.35) / lis.length);
        }
      });
    }
    function ask() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    addEventListener("scroll", ask, { passive: true }); addEventListener("resize", ask); frame();
  }
  function initTilt(root) {
    if (REDUCE) return;
    $all("[data-nh-tilt] > *", root).forEach(function (el) {
      el.addEventListener("pointermove", function (e) {
        if (e.pointerType === "touch") return;
        var r = el.getBoundingClientRect();
        el.style.setProperty("--rx", (((e.clientY - r.top) / r.height) - 0.5) * -10 + "deg");
        el.style.setProperty("--ry", (((e.clientX - r.left) / r.width) - 0.5) * 12 + "deg");
        el.style.setProperty("--mx", ((e.clientX - r.left) / r.width) * 100 + "%");
        el.style.setProperty("--my", ((e.clientY - r.top) / r.height) * 100 + "%");
      });
      el.addEventListener("pointerleave", function () { el.style.removeProperty("--rx"); el.style.removeProperty("--ry"); });
    });
  }
  function initCalc(root) {
    var c = $("[data-nh-calc]", root); if (!c) return;
    var input = $("input[type=range]", c), out = $("[data-n]", c), ours = +c.getAttribute("data-ours"), pot = +c.getAttribute("data-potted"), max = +input.max;
    var cur = { o: 0, p: 0, s: 0 }, raf;
    function fmt(cents) { return "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }); }
    function paint(n, animate) {
      var to = { o: ours * n, p: pot * n, s: (pot - ours) * n };
      out.textContent = n + (n === 1 ? " plant" : " plants");
      $("[data-bar=potted]", c).style.width = (n / max * 100) + "%";
      $("[data-bar=ours]", c).style.width = (n / max * 100 * ours / pot) + "%";
      input.style.setProperty("--fill", ((n - input.min) / (max - input.min) * 100) + "%");
      cancelAnimationFrame(raf);
      var from = { o: cur.o, p: cur.p, s: cur.s }, t0 = performance.now(), dur = (animate && !REDUCE && !document.hidden) ? 380 : 0;
      (function step(t) {
        var k = dur ? Math.min(1, (t - t0) / dur) : 1; k = 1 - Math.pow(1 - k, 3);
        cur = { o: from.o + (to.o - from.o) * k, p: from.p + (to.p - from.p) * k, s: from.s + (to.s - from.s) * k };
        $("[data-tot=ours]", c).textContent = fmt(Math.round(cur.o));
        $("[data-tot=potted]", c).textContent = fmt(Math.round(cur.p / 100) * 100) + "+";
        $("[data-save]", c).textContent = fmt(Math.round(cur.s / 100) * 100) + "+";
        if (k < 1) raf = requestAnimationFrame(step);
      })(t0);
    }
    input.addEventListener("input", function () { paint(+input.value, true); });
    input.addEventListener("change", function () { track("savings_slider", { plants: +input.value }); });
    paint(+input.value, false);
  }

  /* ---------------- Shared kit for every redesigned template ([data-nh]) ---------------- */
  function initReveal(root) {
    /* Content is visible by default; the hidden start state only applies after .nh-js is set,
       and anything still hidden is swept in on scroll or after 2.5s. */
    try {
      var rs = $all(".nh-r", root);
      rs.forEach(function (r) { $all(".nh-goal, .nh-card, .nh-how li, .nh-tile", r).forEach(function (el, i) { el.style.setProperty("--i", i % 8); }); });
      if ("IntersectionObserver" in window && !REDUCE) {
        root.classList.add("nh-js");
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } }); }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
        rs.forEach(function (r) { io.observe(r); });
        var sweep = function () { rs.forEach(function (r) { if (!r.classList.contains("is-in") && r.getBoundingClientRect().top < innerHeight * 0.95) r.classList.add("is-in"); }); };
        setTimeout(sweep, 2500);
        addEventListener("scroll", function () { clearTimeout(sweep.t); sweep.t = setTimeout(sweep, 120); }, { passive: true });
      }
    } catch (e) { root.classList.remove("nh-js"); }
  }
  function initZoneText(root) {
    Loc.on(function (loc) {
      var w = loc && (loc.windows || [])[0];
      $all("[data-nrn-zone-suffix]", root).forEach(function (el) { el.textContent = loc ? " to Zone " + loc.zoneFull : ""; });
      $all("[data-nrn-zone-in]", root).forEach(function (el) { el.textContent = loc ? " in Zone " + loc.zoneFull : ""; });
      $all("[data-nrn-zone-for]", root).forEach(function (el) { el.textContent = loc ? " for Zone " + loc.zoneFull : " for your zone"; });
      $all("[data-nrn-reserve]", root).forEach(function (el) {
        el.textContent = w ? "Order now to hold yours. Zone " + loc.zoneFull + " ships " + fmtDate(w.start) + " – " + fmtDate(w.end) + ", when it's planting time." : "Order now to hold yours. It ships dormant when it's planting time in your zone.";
      });
      $all("[data-nrn-next-short]", root).forEach(function (el) { el.textContent = w ? " · " + (w.season === "fall" ? "Fall" : "Spring") + " ships " + fmtDate(w.start) : ""; });
      $all("[data-nrn-zone-link]", root).forEach(function (a) {
        var label = $("[data-label]", a);
        if (loc) {
          var zz = Math.min(Math.max(loc.zone, 2), 9), zl = zz === loc.zone ? loc.zoneFull : String(zz);
          a.href = "/collections/usda-zone-" + zz + "-plants";
          if (label) label.textContent = zz === loc.zone ? (a.classList.contains("nh-btn") ? "Shop plants for Zone " + zl : "See all for Zone " + zl) : "See all Zone " + zl + " plants (closest we carry)";
        }
      });
      $all("[data-nrn-next-window]", root).forEach(function (el) { if (w) el.textContent = "Zone " + loc.zoneFull + ": " + (w.season === "fall" ? "fall" : "spring") + " ships " + fmtDate(w.start) + " – " + fmtDate(w.end) + ", " + orderBy(w) + "."; });
    });
  }
  function cardSeason(card) {
    var w = (Loc.current && Loc.current.windows) || [];
    var first = w[0] ? w[0].season : "spring";
    var fall = card.getAttribute("data-fall"), spring = card.getAttribute("data-spring");
    var hasFall = w.some(function (x) { return x.season === "fall"; });
    if (Loc.current && !hasFall) return spring || null;
    return (first === "fall" ? (fall || spring) : (spring || fall)) || null;
  }
  function cardFits(c, loc) {
    if (!loc) return true;
    var zones = (c.getAttribute("data-zones") || "").split(",").filter(Boolean).map(Number);
    var cant = (c.getAttribute("data-cant") || "").split(",");
    return (!zones.length || zones.indexOf(loc.zone) !== -1) && cant.indexOf(loc.state) === -1 && !!cardSeason(c);
  }
  function initQuickAdd(root) {
    var status = $("[data-nrn-cart-status]", root);
    root.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-nrn-quick-add]"); if (!btn) return;
      var card = btn.closest("[data-nrn-card]"); var id = cardSeason(card); if (!id || btn.disabled) return;
      var qty = +card.getAttribute("data-qty") || 1, label = btn.textContent;
      btn.disabled = true; btn.textContent = "Adding…";
      var l = Loc.current;
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: +id, quantity: qty }], sections: "cart-icon-bubble" }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          btn.disabled = false; btn.classList.add("is-added"); btn.textContent = "Added ✓";
          track("quick_add", { product: (card.querySelector(".nh-card__name") || {}).textContent, qty: qty, merch: +card.getAttribute("data-push") > 0 ? "push" : "hot", page: root.getAttribute("data-nh") || "" });
          var bubble = document.getElementById("cart-icon-bubble");
          if (bubble && j.sections && j.sections["cart-icon-bubble"]) { var tmp = document.createElement("div"); tmp.innerHTML = j.sections["cart-icon-bubble"]; var inner = tmp.querySelector(".shopify-section") || tmp; bubble.innerHTML = inner.innerHTML; }
          if (status) status.textContent = "Added to cart."; try { document.dispatchEvent(new CustomEvent("nrn:cart-added", { detail: { card: card, qty: qty } })); } catch (err2) {}
          if (l) { try { fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { "Shipping ZIP": l.zip, "USDA zone": l.zoneFull } }) }); } catch (err) {} }
          setTimeout(function () { btn.classList.remove("is-added"); btn.textContent = label; }, 2500);
        })
        .catch(function (err) { btn.disabled = false; btn.textContent = label; if (status) status.textContent = (err && err.description) || "Couldn’t add that. Try the plant page."; });
    });
  }
  function initKit(root) {
    if (root._nhKit) return; root._nhKit = true;
    initParallax(root); initTilt(root); initCalc(root); initReveal(root); initZoneText(root); initQuickAdd(root); initSchedule(root); initZoneFinder(root);
  }

  /* ---------------- Info pages ----------------
     [data-nh-schedule]: full zone schedule from the zone API (single source of truth), visitor's zone highlighted.
     [data-nh-zonefinder]: ZIP form that sets the visitor location and shows their zone and dates.
     [data-zone-link]: zone tiles, the visitor's zone highlighted. */
  var scheduleP = null;
  function getSchedule() { if (!scheduleP) scheduleP = fetch(API + "/zone?schedule=all").then(function (r) { return r.json(); }); return scheduleP; }
  function fmtWin(w) { return fmtDate(w.start) + " – " + fmtDate(w.end) + ", " + w.yearLabel; }
  function initSchedule(root) {
    $all("[data-nh-schedule]", root).forEach(function (box) {
      var tb = $("tbody", box);
      getSchedule().then(function (d) {
        var rows = Object.keys(d.zones).map(Number).sort(function (a, b) { return a - b; });
        tb.innerHTML = "";
        rows.forEach(function (z) {
          var Z = d.zones[z], sp = (Z.windows || []).filter(function (w) { return w.season === "spring"; })[0], fa = (Z.windows || []).filter(function (w) { return w.season === "fall"; })[0];
          var tr = document.createElement("tr"); tr.setAttribute("data-z", z);
          var th = document.createElement("th"); th.scope = "row"; th.textContent = z === 3 ? "Zones 1–3" : "Zone " + z; tr.appendChild(th);
          var td1 = document.createElement("td"); td1.textContent = Z.spring ? (sp ? fmtWin(sp) : Z.spring.shipStart + " – " + Z.spring.shipEnd) : "—"; tr.appendChild(td1);
          var td2 = document.createElement("td"); td2.textContent = Z.spring ? (sp ? (sp.pastDeadline ? "Order now" : fmtDate(sp.deadline)) : Z.spring.deadline) : "—"; tr.appendChild(td2);
          var td3 = document.createElement("td"); td3.textContent = Z.fall ? (fa ? fmtWin(fa) : Z.fall.shipStart + " – " + Z.fall.shipEnd) : "No fall shipping"; tr.appendChild(td3);
          var td4 = document.createElement("td"); td4.textContent = Z.fall ? (fa ? (fa.pastDeadline ? "Order now" : fmtDate(fa.deadline)) : Z.fall.deadline) : "—"; tr.appendChild(td4);
          tb.appendChild(tr);
        });
        Loc.on(function (loc) { $all("tr[data-z]", tb).forEach(function (tr) { tr.classList.toggle("is-mine", !!loc && +tr.getAttribute("data-z") === Math.min(Math.max(loc.zone, 3), 10)); }); });
      }).catch(function () { var m = $("[data-nh-schedule-msg]", box); if (m) m.hidden = false; });
    });
  }
  function initZoneFinder(root) {
    $all("[data-nh-zonefinder]", root).forEach(function (form) {
      var input = $("input", form), out = $("[data-nh-zoneresult]", root), msg = $("[data-nh-zonemsg]", form);
      form.addEventListener("submit", function (e) {
        e.preventDefault(); var zip = (input.value || "").trim();
        if (!/^\d{5}$/.test(zip)) { if (msg) msg.textContent = "Enter a 5-digit US ZIP code."; return; }
        if (msg) msg.textContent = "Looking up " + zip + "…";
        Loc.fromZip(zip, "zip").then(function () { if (msg) msg.textContent = ""; track("zone_lookup", { page: root.getAttribute("data-nh") }); }).catch(function () { if (msg) msg.textContent = "We couldn't find that ZIP. Check it and try again."; });
      });
      Loc.on(function (loc) {
        if (!out || !loc) return;
        if (input && !input.value) input.value = loc.zip;
        var ws = loc.windows || [];
        out.hidden = false; out.innerHTML = "";
        var p1 = document.createElement("p"); p1.innerHTML = "<b></b>"; p1.firstChild.textContent = (loc.city ? loc.city + ", " + loc.state + " " : "") + loc.zip + " is USDA Zone " + loc.zoneFull + "."; out.appendChild(p1);
        var p2 = document.createElement("p");
        p2.textContent = ws.length ? ws.map(function (w) { return (w.season === "fall" ? "Fall" : "Spring") + " shipping: " + fmtWin(w) + " (" + orderBy(w) + ")"; }).join(". ") + "." : "Spring pre-orders open soon.";
        out.appendChild(p2);
        var a = document.createElement("a"); a.className = "nh-btn nh-btn--sprout nh-btn--arrow"; var zz2 = Math.min(Math.max(loc.zone, 2), 9); a.href = "/collections/usda-zone-" + zz2 + "-plants"; a.textContent = zz2 === loc.zone ? "Shop plants for Zone " + loc.zoneFull : "Shop Zone " + zz2 + " plants (closest we carry)"; a.style.marginTop = "12px"; out.appendChild(a);
      });
    });
    Loc.on(function (loc) { $all("[data-zone-link]", root).forEach(function (el) { el.classList.toggle("is-mine", !!loc && +el.getAttribute("data-zone-link") === Math.min(Math.max(loc.zone, 2), 9)); }); });
  }

  /* Home: one row of 8, best sellers first with at-risk plants woven in */
  function initHome(root) {
    initKit(root);
    var cards = $all("[data-nrn-card]", root);
    Loc.on(function (loc) {
      var picked = merchPick(cards.filter(function (c) { return cardFits(c, loc); }), 8);
      var note = $("[data-nrn-zone-note]", root);
      if (!picked.length && loc && cards.length) {
        var near = Math.min(Math.max(loc.zone, 2), 9);
        picked = merchPick(cards.filter(function (c) {
          var zs = (c.getAttribute("data-zones") || "").split(",").filter(Boolean).map(Number);
          var cant = (c.getAttribute("data-cant") || "").split(",");
          return zs.indexOf(near) !== -1 && cant.indexOf(loc.state) === -1;
        }), 8);
        if (!note) { note = document.createElement("p"); note.className = "nh-sub nh-zone-note"; note.setAttribute("data-nrn-zone-note", ""); var hd = $(".nh-head", root); if (hd) hd.appendChild(note); }
        if (note) { note.hidden = false; note.textContent = "None of our plants are rated for Zone " + loc.zoneFull + " yet. These are rated to Zone " + near + ", the closest we carry; check each plant's range before ordering."; }
      } else if (note) note.hidden = true;
      var rail = cards.length ? cards[0].parentNode : null;
      cards.forEach(function (c) { c.hidden = picked.indexOf(c) === -1; });
      if (rail) picked.forEach(function (c) { rail.appendChild(c); });
      track("home_row", { slots: picked.map(function (c) { return (+c.getAttribute("data-push") > 0 ? "P:" : "H:") + (c.querySelector(".nh-card__name") || {}).textContent; }).join("|") });
    });
  }

  /* Collection: every plant, filtered to the visitor's zone (toggle), chips, sort; "Recommended" uses the sell-out engine */
  function initCollection(root) {
    initKit(root);
    var cards = $all("[data-nrn-card]", root), grid = $("[data-nh-grid]", root);
    var zoneT = $("[data-nh-zone-toggle]", root), sortS = $("[data-nh-sort]", root), countEl = $("[data-nh-count]", root), empty = $("[data-nh-empty]", root);
    var chips = $all("[data-nh-chip]", root), active = {};
    function apply() {
      var loc = Loc.current, onlyZone = zoneT && zoneT.checked && !!loc;
      var list = cards.filter(function (c) {
        if (onlyZone && !cardFits(c, loc)) return false;
        var tags = "," + (c.getAttribute("data-tags") || "") + ",";
        for (var k in active) if (active[k] && tags.indexOf("," + k + ",") === -1) return false;
        return true;
      });
      var sort = sortS ? sortS.value : "rec";
      if (sort === "rec") list = merchPick(list, list.length);
      else list.sort(function (a, b) {
        if (sort === "best") return (+a.getAttribute("data-hot")) - (+b.getAttribute("data-hot"));
        if (sort === "price") return (+a.getAttribute("data-price")) - (+b.getAttribute("data-price"));
        if (sort === "name") return a.getAttribute("data-name").localeCompare(b.getAttribute("data-name"));
        return 0;
      });
      cards.forEach(function (c) { c.hidden = list.indexOf(c) === -1; });
      list.forEach(function (c) { grid.appendChild(c); });
      if (countEl) countEl.textContent = list.length + (list.length === 1 ? " plant" : " plants") + (onlyZone ? " for Zone " + loc.zoneFull : "");
      if (empty) empty.hidden = list.length > 0;
    }
    if (zoneT) zoneT.addEventListener("change", function () { apply(); track("collection_zone_toggle", { on: zoneT.checked }); });
    if (sortS) sortS.addEventListener("change", function () { apply(); track("collection_sort", { sort: sortS.value }); });
    chips.forEach(function (ch) { ch.addEventListener("click", function () { var k = ch.getAttribute("data-nh-chip"); active[k] = !active[k]; ch.setAttribute("aria-pressed", active[k] ? "true" : "false"); apply(); }); });
    Loc.on(function (loc) { if (zoneT) { zoneT.disabled = !loc; var lab = $("[data-nh-zone-label]", root); if (lab) lab.textContent = loc ? "Only plants for Zone " + loc.zoneFull : "Set your ZIP to filter by zone"; } apply(); });
    apply();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLocDialog();
    $all('[data-nrn-pdp]').forEach(initPDP);
    $all('[data-nrn-home]').forEach(initHome);
    $all('[data-nrn-collection]').forEach(initCollection);
    $all('[data-nrn-row]').forEach(initHome);
    $all('[data-nh]').forEach(initKit);
    Loc.init();
  });
})();
